import { render, staticRenderFns } from "./ManshonRegist.vue?vue&type=template&id=1588c814&"
import script from "./ManshonRegist.vue?vue&type=script&lang=js&"
export * from "./ManshonRegist.vue?vue&type=script&lang=js&"
import style0 from "./ManshonRegist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports